  

'use strict';

if (window.jQuery) var $ = window.jQuery;

$(function () {
  aweHosoren.init();

  //== DEMO ONLY
  aweSearchMenubar();
  
  image2background();
});

function aweMaps(mapElement) {
  if (! mapElement) {
    mapElement = '#contact-map';
  }

  var map = new GMaps({
    el: mapElement,
    lat: $(mapElement).data('lat'),
    lng: $(mapElement).data('lng'),

    draggable: true,
    scrollwheel: false
  });

  map.addMarker({
    lat: $(mapElement).data('lat'),
    lng: $(mapElement).data('lng'),
  });
}

// ===

function aweSearchMenubar() {
    var $navbar = $('.awemenu-nav');

    var $searchForm = $('#menubar-search-form');
    var $openSearch = $('#open-search-form');
    var $closeSearch = $('#close-search-form');
    var $closeLogin =  $('#close-login-form');
    var $openLogin  =  $('#openLogin');
    var $loginForm = $('#menubar-login-form');
    var $wrapper      =  $('#wrapper');
    $openSearch.on('click', function(e) {
        e.preventDefault();
        $searchForm.toggleClass('open');
        $wrapper.toggleClass('bg-opacity');
        setTimeout(function() {
            $searchForm.find('input').focus();
        }, 250);
    });

    $openLogin.on('click', function(e) {
        e.preventDefault();
        $loginForm.toggleClass('open');
        $wrapper.toggleClass('bg-opacity');
    });

    $closeSearch.on('click', function(e) {
        e.preventDefault();
        $searchForm.removeClass('open');
        $wrapper.removeClass('bg-opacity');
    });

    $closeLogin.on('click', function(e) {
        e.preventDefault();
        $loginForm.removeClass('open');
        $wrapper.removeClass('bg-opacity');
    });

    $searchForm.keyup(function(e) {
        if (e.keyCode == 27 && $searchForm.hasClass('open')) {
            $searchForm.removeClass('open');
            $wrapper.removeClass('bg-opacity');
        }
    });


    $(window).resize(function() {
        if ($navbar.hasClass('awemenu-mobile')) {
            $searchForm.width('100%');
            $searchForm.css({right: '0'});
        } else {
            var $awemenu = $('.awemenu-nav .awemenu');
            var $aweicon = $('.awemenu-nav .navbar-icons');

            var width = $awemenu.width() + 50;
            var offsetRight = $aweicon.width() + 20;

            $searchForm.width('inherit');
            $searchForm.css({right: 'inherit'});
        }
    }).trigger('resize');

}

$(document).click(function (e){
  var container = $("#menubar-search-form");
  var container2=$("#open-search-form");
  if (!container.is(e.target) && !container2.is(e.target) && container.has(e.target).length === 0  && container2.has(e.target).length === 0){ 
    $('#menubar-search-form').removeClass('open');
  }
});


// ===
function aweMainSlider() {
  var $slider = $('.main-slider');

  $slider.owlCarousel({
    items: 1,
    nav: true,
    dots: true,
    autoPlay: true,
    onInitialized: function() {
      $slider.find('.owl-item').each(function() {
        var $owlItem = $(this);

        var $mainSlide = $owlItem.find('.main-slider-item');
        var $mainImage = $owlItem.find('.main-slider-image > img');

        if ($mainSlide.length && $mainImage.length) {
          $mainSlide.addClass('background');
          $mainSlide.css('background-image', 'url('+$mainImage.attr('src')+')');

          $mainImage.css({
            opacity: 0,
            visibility: 'hidden'
          });
        }
      });
    }
  });
}

function awePriceSlider($selector) {
  if (! $selector) {
    $selector = $('#price-slider');
  }

  $selector.slider({
    values: [35, 250],
    min: 10,
    max: 320,
    step: 10,
    range: true,
    slide: function(e, ui) {
      $('#amount').text('$'+ui.value);
    }
  });
}

function aweBlogMasonry($selector) {
  if (! $selector) {
    $selector = $('.blog-masonry .row-masonry');
  }

  $selector.imagesLoaded(function() {
    $selector.masonry({
      itemSelector: '.column',
      columnWidth: '.column'
    });
  });
}

function aweProfolioIsotope($selector) {
  if (! $selector) {
    $selector = $('.grid');
  }

  $selector.imagesLoaded(function() {
    var $grid = $selector.isotope({
      itemSelector: '.grid-item',
      layoutMode: 'masonry'
    });
  });

  $('.awe-nav').on('click', 'a', function(e) {
    e.preventDefault();

    $(this).parents('.awe-nav').find('li').removeClass('active');
    $(this).closest('li').addClass('active');

    var filter = $(this).attr('data-filter');
    $selector.isotope({ filter: filter });
  });
}

function aweProfolioDetail() {
  $('.lasted-portfolio-carousel').owlCarousel({
    items: 4,
    nav: true,
    dots: false,
    margin: 30,
    responsive: {
      0: { items: 1 },
      480: { items: 2 },
      768: { items: 3 },
      980: { items: 4 }
    }
  });

  $('.image').magnificPopup({
    type: 'image',
    delegate: 'a',
    gallery: { enabled: true }
  });
}

function aweProductSidebar() {
  var $filterSidebar = $('#shop-widgets-filters');
  var $toggleButton = $('#open-filters');

  var $overlay = $('body').find('.widgets-filter-overlay');

  function _open() {
    $filterSidebar.addClass('open');
    $toggleButton.addClass('open');

    if (! $overlay.length) {
      $('body').append('<div class="widgets-filter-overlay"></div>');
    }

    $('body').addClass('open-filters-open');
  }

  function _close() {
    $filterSidebar.removeClass('open');
    $toggleButton.removeClass('open');
    $(document).find('.widgets-filter-overlay').remove();
    $('body').removeClass('open-filters-open');
  }

  $toggleButton.on('click', function() {
    if (! $filterSidebar.hasClass('open')) {
      _open();
    } else {
      _close();
    }
  });

  $('html').on('click', '.widgets-filter-overlay', function() {
    _close();
  });
}

function aweProductRender(thumbHorizontal) {
  if (Modernizr && ! Modernizr.touch) {
    $('.easyzoom').easyZoom();
  }

  var sMain = new Swiper('.product-slider-main', {
    loop: false,

    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev'
  });

  var sThumb = new Swiper('.product-slider-thumbs', {
    loop: false,
    centeredSlides: true,
    spaceBetween: thumbHorizontal ? 15 : 0,
    slidesPerView: thumbHorizontal ? 4 : 3,
    direction: thumbHorizontal ? 'horizontal' : 'vertical',
    slideToClickedSlide: true
  });

  sMain.params.control = sThumb;
  sThumb.params.control = sMain;
}
function image2background(){
    $(window).load(function() {
      var image2background = $('.image2background').children('img');
      image2background.before(function () {
        var srcImg = $(this).attr('src');
        return '<div class="item-img" style="background-image: url(' + srcImg + ')">';
      });
    });
}



var selectCallback = function(variant, selector) {
  if (variant) {
    if (variant.available) {
      // Selected a valid variant that is available.
      $('#add').removeClass('disabled').removeAttr('disabled').val('Add to Cart').fadeTo(200,1);
    } else {
      // Variant is sold out.
      $('#add').val('Sold Out').addClass('disabled').attr('disabled', 'disabled').fadeTo(200,0.5);        
    }
    // Whether the variant is in stock or not, we can update the price and compare at price.
    if ( variant.compare_at_price > variant.price ) {
      $('#price-field').html('<span class="product-price on-sale">'+ Shopify.formatMoney(variant.price, "") +'</span>'+'&nbsp;<s class="product-compare-price">'+Shopify.formatMoney(variant.compare_at_price, "")+ '</s>');
    } else {
      $('#price-field').html('<span class="product-price">'+ Shopify.formatMoney(variant.price, "") + '</span>' );
    }        
  } else {
    // variant doesn't exist.
    $('#add').val('Unavailable').addClass('disabled').attr('disabled', 'disabled').fadeTo(200,0.5);
  }
}

$(".swiper-container").each( function(){
  var config = {
    spaceBetween: $(this).data('margin'),
    slidesPerView: $(this).data('items'),
    direction: $(this).data('direction'),
    paginationClickable: true,
    grabCursor: true 
  };    
  var swiper = new Swiper(this, config);

});
// ================== js uruana=============
function sportHover() {
    var sportLink = $('.sport-link');

    var windowWidth = window.innerWidth;

    sportLink.each(function(){
        var el = $(this);

        if(windowWidth > 640) {
            var elWidth = el.outerWidth();
            el.on('mouseover', function() {
                /* Stuff to do when the mouse enters the element */
                var numberOther = elWidth - 5;
                var number = elWidth + 12;
                sportLink.css('width', numberOther);
                el.css('width', number);
            });

            el.on('mouseout', function() {
                /* Stuff to do when the mouse enters the element */
                sportLink.removeAttr('style');
            });
        } else {
            el.on('mouseover', function() {
                sportLink.removeAttr('style');
            });

            el.on('mouseout', function() {
                sportLink.removeAttr('style');
            });
        }
    });
}
function addClassHeader() {
    var scrollTrigger = 50;
    var scrollTop = $(window).scrollTop();
    if (scrollTop > scrollTrigger) {
        $('#header.header-v3').addClass('background-white');
    } else {
        $('#header.header-v3').removeClass('background-white');
    }
}
$(window).on('scroll', function() {
    addClassHeader();
});

$(window).on('load resize', function(){
    sportHover();
});




// ================== New lable=============
$('.product .product-inner').each(function(){

  var pubDate = $(this).data("publish-date");
  var pubDate2=pubDate.substr(0, 10);
  var todayDate = new Date();
  var time1 = Date.parse(pubDate2);
  var time2 = Date.parse(todayDate);
  var time= Math.abs(time2 - time1);
  var a= 1000*24*60*60*1000;

  if(time < a){
    $('.product .product-inner .new').show();

  }
});

$(document).ready(function(){
  if($(".product-body-list").children().length > 0){
  
    $('.view-mode .grid').removeClass('active');
     $('.view-mode .list').addClass('active');
  }
  
//   fix load //
  $('a').click(function(){
    $('.engo-popup').removeClass('active');
  });
  $('.dropdown-content li').click(function(){
    $('.engo-popup').removeClass('active');
  });
  
//   end fix load
  
//   menu
  
 $(document).on('click','.awemenu-item a .awemenu-arrow.fa-angle-down',function(){
            /* var fi = $(this).parent().parent();
             fi.find('.awemenu-submenu.awemenu-megamenu').show();
             */
             $('.awemenu-nav.awemenu-mobile').addClass('awemenu-active');
             
      });
  
      $(document).on('click','.awemenu-item a .awemenu-arrow.fa-close',function(){
          /*
          var fa = $(this).parent().parent();
         fa.find('.awemenu-submenu.awemenu-megamenu').hide();*/
             $('.awemenu-nav.awemenu-mobile').addClass('awemenu-active');
      });

  
      // SLIDE DOWN MENU
      $('.awemenu-bars').click(function(){
          $(".dropdown-cus").slideToggle();
      });  
      
      $('.sub-menu-cus').click(function(){
        if($(window).width() < 1200){
           var submenu = $(this).parent().find('.drop-menu-cus');
          submenu.slideToggle();
          $(this).find('i').toggleClass('fa-plus fa-minus');
        }
          
      });  

      $(window).on('load, resize', function(){
          if ($(window).width()>1200) {
              $('.drop-menu-cus').each(function(){
                  $(this).addClass('show-submenu');
              });
          }
          else{
              $('.drop-menu-cus').each(function(){
                    $(this).removeClass('show-submenu');
                });
          }
      }); 
  
//   breadcrumb
  
  $(function() {
    $('#breadcrumbs').breadcrumbsGenerator({
        sitemaps: '.awemenu', 
    });
  });
  
//    $(window).on('load', function(){
     
//      var text = $('.breadcrumb .collect span').text();
//      var tx = $('a:contains('+text+')').parents('.awemenu-item');
//      var replace = tx.find('.title-menu-title').text();
//      $('.link-title a').text(replace);

//    });
 
//   Remove button share
  jQuery(window).on('load', function() {
    if (jQuery(window).width()<=1060) {
        $('.at-share-dock').remove();
    }
  });
  jQuery(window).on('resize', function() {
    if (jQuery(window).width()<=1060) {
        $('.at-share-dock').remove();
    }
  });
  
});


 jQuery(window).on('load, resize', function(){
   if(jQuery(window).width()<1200) { 
     var third = jQuery('.awemenu-item').eq(2).addClass('sub-third');
     $('.sub-third').find('.drop-menu-cus').css('display','block!important');
    
   }

jQuery(window).on('load', function(){
  if (!jQuery('.menu-title-res').length) {
      jQuery('<span class="menu-title-res">Menu</span>').insertAfter('.awemenu-bars');
  }
  
});

   
//    fancybox
//    jQuery('.img_lookbook').fancybox({
//       'transitionIn'  : 'none',
//       'transitionOut'  : 'none',
//       'nextEffect'  :  'fade',
//       'prevEffect'  :  'fade',
     
//        helpers : {
//         title : {
//          type: 'over'
//         },
//         buttons	: {}
//        },
//      beforeShow : function() {
//        this.title = (this.index + 1) + '/' + this.group.length + '   ' + (this.title ? '' + this.title + '' : '')  ;
//       }
     
//    } );
   
    //  pinterest   
  
   
  $('.main-img').imgPin({

    pinImg : '//cdn.shopify.com/s/files/1/1931/3943/files/pinterest_5069a974-0c4c-479b-9e28-ca43f60169d2.png?v=1534746608',

    position: 1,

  });
   
   $('.lookbook_total').lightGallery({
        thumbnail:true,
        animateThumb: false,
        showThumbByDefault: false
   }); 
    
   


   jQuery(window).on('load', function(){
// 	 setTimeout(function(){ 
         $('.lookbook_total').masonry({
           // options...
           itemSelector: '.lookbook_item'
         });
//      }, 500);
   });
     
   
  
   
   
//    $('.lookbook_item').click(function(){
//      setTimeout(function(){ 
//        $('.lg-image').imgPin({

//        pinImg : '//cdn.shopify.com/s/files/1/1931/3943/files/pinterest_5069a974-0c4c-479b-9e28-ca43f60169d2.png?v=1534746608',

//        position: 1,

//      });

//      }, 1000);  
//    });
   
   
//    $(document).on('click','.lg-icon',function(){
//      setTimeout(function(){ 
//        $('.lg-image').imgPin({

//        pinImg : '//cdn.shopify.com/s/files/1/1931/3943/files/pinterest_5069a974-0c4c-479b-9e28-ca43f60169d2.png?v=1534746608',

//        position: 1,

//      });

//      }, 1000);  
//    });
   
  
}); 






